import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
 standalone: false,
  name: 'mxEnumAsString',
})
export class MxEnumAsStringPipe implements PipeTransform {
  constructor() {}
  transform(value: any, type: any, typeAsString: string): any {
    if (type && typeAsString) {
      return `enum:${typeAsString}.${type[value]}`;
    }
    return value;
  }
}

